import {
  SHOW_MODAL,
  HIDE_MODAL,
  USER_LOGOUT
} from '../actions/types'

const initialState = {
  modalShown: false,
  modalType: ''
}

export default function modal(state = initialState, action){
  const { modal } = action
  let newState = null;

  switch (action.type) {
    case SHOW_MODAL:
      newState = {
        modalShown: true,
        modalType: modal.modalType,
        optionalProps: modal.optionalProps
      }
      return newState
    case HIDE_MODAL:
      newState = {
        modalShown: false,
        modalType: '',
        optionalProps: null
      }
      return newState
    case USER_LOGOUT:
      return initialState
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/modal.js